import React from 'react';

export default function Services() {
  return (
    <section id="services" className="py-5 bg-light" style={{ fontFamily: "'Montserrat', sans-serif" }}>
      <div className="container py-5">
        
        {/* Section Heading with more context */}
        <div className="text-center mb-5">
          <span className="text-warning fw-bold text-uppercase" style={{ letterSpacing: '2px', fontSize: '14px' }}>
            What We Do
          </span>
          <h2 className="display-5 fw-bolder mt-2 mb-3" style={{ color: '#0f2b5b' }}>
            Our Core Expertise
          </h2>
          <div className="bg-warning mx-auto rounded" style={{ width: '80px', height: '4px' }}></div>
          <p className="text-muted mt-4 mx-auto" style={{ maxWidth: '750px', fontSize: '1.1rem', lineHeight: '1.8' }}>
            At Divine Solar Energy, we bring you industry-leading solar manufacturing and end-to-end power solutions designed for maximum efficiency, durability, and a greener tomorrow.
          </p>
        </div>
        
        <div className="row g-4 mt-2">
          
          {/* Service Card 1 */}
          <div className="col-lg-4 col-md-6">
            <div className="card h-100 border-0 shadow-sm service-card rounded-4 overflow-hidden" style={{ borderBottom: '5px solid #0f2b5b' }}>
              <div className="service-img-wrapper" style={{ height: '220px' }}>
                <img 
                  src="https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?auto=format&fit=crop&w=800&q=80" 
                  className="w-100 h-100" 
                  style={{ objectFit: 'cover' }} 
                  alt="Solar Power Generation" 
                />
              </div>
              <div className="card-body p-4 d-flex flex-column">
                <h3 className="h4 fw-bold mb-3" style={{ color: '#0f2b5b' }}>Solar Manufacturing & Power Gen.</h3>
                <p className="text-muted mb-4" style={{ lineHeight: '1.7' }}>
                  We specialize in the advanced manufacturing of high-efficiency solar energy equipment. Using cutting-edge technology, our solar panels are engineered to deliver maximum power output, durability against harsh weather, and long-term reliability for both commercial and residential setups.
                </p>
                <div className="mt-auto">
                  <span className="text-warning fw-bold" style={{ cursor: 'pointer' }}>Explore More →</span>
                </div>
              </div>
            </div>
          </div>
          
          {/* Service Card 2 */}
          <div className="col-lg-4 col-md-6">
            <div className="card h-100 border-0 shadow-sm service-card rounded-4 overflow-hidden" style={{ borderBottom: '5px solid #ffc107' }}>
              <div className="service-img-wrapper" style={{ height: '220px' }}>
                <img 
                  src="https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?auto=format&fit=crop&w=800&q=80" 
                  className="w-100 h-100" 
                  style={{ objectFit: 'cover' }} 
                  alt="Sustainable Solutions" 
                />
              </div>
              <div className="card-body p-4 d-flex flex-column">
                <h3 className="h4 fw-bold mb-3" style={{ color: '#0f2b5b' }}>Sustainable & Custom Solutions</h3>
                <p className="text-muted mb-4" style={{ lineHeight: '1.7' }}>
                  Transitioning to clean energy should be seamless. We provide comprehensive, end-to-end sustainable solutions tailored to your specific energy needs. By optimizing your power consumption, we help businesses and homes significantly reduce their carbon footprint and slash electricity bills.
                </p>
                <div className="mt-auto">
                  <span className="text-warning fw-bold" style={{ cursor: 'pointer' }}>Explore More →</span>
                </div>
              </div>
            </div>
          </div>
          
          {/* Service Card 3 */}
          <div className="col-lg-4 col-md-6">
            <div className="card h-100 border-0 shadow-sm service-card rounded-4 overflow-hidden" style={{ borderBottom: '5px solid #0f2b5b' }}>
              <div className="service-img-wrapper" style={{ height: '220px' }}>
                <img 
                  src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=800&q=80" 
                  className="w-100 h-100" 
                  style={{ objectFit: 'cover' }} 
                  alt="Certified & Trusted" 
                />
              </div>
              <div className="card-body p-4 d-flex flex-column">
                <h3 className="h4 fw-bold mb-3" style={{ color: '#0f2b5b' }}>Certified, Compliant & Trusted</h3>
                <p className="text-muted mb-4" style={{ lineHeight: '1.7' }}>
                  Quality and transparency are at the core of our business. As a fully registered MSME and GST-compliant enterprise, we adhere to strict government and industry standards. From manufacturing to installation, we guarantee top-tier service, rigorous quality checks, and unwavering customer support.
                </p>
                <div className="mt-auto">
                  <span className="text-warning fw-bold" style={{ cursor: 'pointer' }}>Explore More →</span>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}